exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".card-pron{background-color:#f6f6f6;border-color:#fff}.card-pron .phonetic{position:absolute;right:5px;top:-15px;width:30px;height:30px;background-color:#ff6969}.card-pron .card-img-top{background-color:#fbb}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2bee075a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pronunciationsOne/Row.vue
// module id = 56
// module chunks = 0